import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formPopupEligibilityMessagePriority_formContainer: {

		},
		formPopupEligibilityMessagePriority_VerticalSpacing: {
			padding: theme.spacing(0, 0, 2, 0),
		},
		formPopupEligibilityMessagePriority_inputContainer: {
			padding: theme.spacing(1, 0, 3, 0),
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		formPopupEligibilityMessagePriority_inputBody: {
			padding: theme.spacing(0, 0),
			width: '100%',
		},
	});
});

export default useStyles;